<template>

    <div class="characteristic-detail-container">
        <van-image
                @click="back"
                width="36px"
                height="36px"
                fit="fit"
                :src="backIcon"/>
        <span class="service-title">Service Information</span>
        <div class="service-container">
            <div class="name-container mt-8">
                <div class="subtitle">Name</div>
                <div class="service-name">{{serviceName($route.params.serviceUUID)}}</div>
            </div>
            <div class="name-container mt-8">
                <div class="subtitle">UUID</div>
                <div class="service-name">{{$route.params.serviceUUID}}</div>
            </div>
        </div>


        <span class="service-title mt-16">Characteristics Information</span>
        <div class="service-container">
            <div class="name-container mt-8">
                <div class="subtitle">Name</div>
                <div class="service-name">{{$route.params.characteristic.aliasName}}</div>
            </div>
            <div class="name-container mt-8">
                <div class="subtitle">UUID</div>
                <div class="service-name">{{$route.params.characteristic.uuid}}</div>
            </div>
        </div>


        <div class="mt-16"><span class="service-title mt-16">Properties</span> <span class="properties-button"
                                                                                     @click="_self[item]()"
                                                                                     v-for="item in getButtonContentProperties()">{{item}}</span>
        </div>
        <div class="service-container">
            <div class="name-container mt-8">
                <div class="subtitle">Properties</div>
                    <div v-show="isSupportNotify()">Notify Data:{{notifyData}}</div>
                </div>
                <!--（Length:{{$route.params.characteristic.data.length}}）-->
                <div class="name-container mt-8">
                    <div class="subtitle">Raw Value(HEX) ({{receivedDate}})</div>
                    <div class="service-name mt-4"> {{receivedData}}</div>
                </div>
            </div>

            <van-popup v-model="showWriteDialog" class="write-dialog" round opened="onPopupOpened">
                <WriteDialog v-on:onCloseBindDialog="onCloseBindDialog"
                             v-on:onSubmitData="onSubmitData"/>
            </van-popup>
        </div>

    </div>
</template>

<script>
    import table from "../utils/ServiceTable"
    import Constant from "../constant/config"
    import bluetoothRepository from "../repository/BluetoothRepository"
    import WriteDialog from "./WriteDialog"
    import {Toast} from "vant"

    export default {
        name      : "CharacteristicDetail",
        components: {WriteDialog},
        data() {
            return {
                receivedData   : this.defaultValue(),
                decoder        : new TextDecoder(),
                showWriteDialog: false,
                backIcon       : require('../assets/back.png'),
                receivedDate   : new Date()
            }
        },
        methods   : {
            back() {
                this.$router.back()
            },
            onCloseBindDialog() {
                this.showWriteDialog = false
            },
            onSubmitData(data) {
                const length = data.length
                if (length === 0) {
                    Toast.success("Send data invalid")
                    return
                }

                let handleData = data.trim().replace(" ", '')
                if (!/[a-fA-F0-9]+/.test(handleData)) {
                    Toast.success("Send data invalid")
                    return
                }
                if (length % 2 !== 0) {
                    handleData = `0${data}`
                }

                let sendData = []
                for (let i = 0; i < handleData.length; i += 2) {
                    sendData.push(parseInt(`${handleData[i]}${handleData[i + 1]}`, 16))
                }

                bluetoothRepository.write(this.$route.params.serviceUUID, this.$route.params.characteristic.uuid, new Uint8Array(sendData))
                    .then(data => {
                        Toast.success("Send successfully")
                    })

                this.showWriteDialog = false
            },
            defaultValue() {
                const characteristic = this.$route.params.characteristic
                return characteristic.data
            },
            toHexString(data) {
                if (!data) {
                    return ''
                }
                let currentHex = []
                Buffer.from(data, 'utf-8').forEach(item => currentHex.push(`0x${item.toString(16)}`))
                return currentHex.join(',')
            },
            serviceName(uuid) {
                return table.findServiceName(uuid)
            },
            characteristicName(uuid) {
                return table.findCharacteristicName(uuid)
            },
            handleProperties(properties) {
                switch (properties) {
                    case Constant.PeripheralProperties.read:
                        bluetoothRepository.read(this.$route.params.serviceUUID, this.$route.params.characteristicUUID)
                            .then(data => {
                                this.receivedData = this.toHexString(data)
                                console.log(`读取到的数据: ${data}`)
                                Toast.success({
                                    message: 'Read successfully'
                                })
                            })
                        break
                    case Constant.PeripheralProperties.writeWithoutResponse:

                        break
                    case Constant.PeripheralProperties.write:

                        break
                    case Constant.PeripheralProperties.notify:

                        break
                    default:
                        propertiesDesc = ""
                }
            },
            getDetailInfomation() {
                const {serviceUUID, characteristicUUID} = this.$route.params
                const peripheralInfo                    = this.$store.state.peripheralInfo
            },
            getButtonContentProperties() {
                let type = []
                this.$route.params.characteristic.propertiesString.split(",").forEach(item => {
                    if (item === 'Read' || item === 'Write' || item === 'WriteWithoutResponse' || item === 'Notify') {
                        type.push(item)
                    }
                })
                return type
            },
            isSupportNotify() {
                let type = []
                this.$route.params.characteristic.propertiesString.split(",").forEach(item => {
                    if (item === 'Notify') {
                        return true
                    }
                })
                return false
            },
            Read() {
                bluetoothRepository.read(this.$route.params.serviceUUID, this.$route.params.characteristic.uuid)
                    .then(data => {
                        this.receivedDate = new Date()
                        this.receivedData = data
                        console.log(`读取到的数据: ${data}`)
                        Toast.success({
                            message: 'Read successfully'
                        })
                    })
            },
            Write() {
                this.showWriteDialog = true
            },
            Notify() {

            },
            WriteWithoutResponse() {
                this.showWriteDialog = true
            }

        },
        computed  : {
            strValue() {
                const receivedData = this.toHexString(this.receivedData || '')
                let data           = []
                receivedData.replace("0x", "").split(",").forEach(item => data.push(parseInt(item, 16)))
                return this.decoder.decode(Buffer.from(data))
            },
            notifyData() {
                const serviceUUID        = this.$route.params.serviceUUID
                const characteristicUUID = this.$route.params.characteristic.uuid
                if (!this.$route.params.characteristic.properties === (this.$route.params.characteristic.properties | Constant.PeripheralProperties.notify)) {
                    return ''
                }

                const data = (this.$store.state.notifyData[serviceUUID] || '') && (this.$store.state.notifyData[serviceUUID][characteristicUUID] || '')
                if (data === '') {
                    return ''
                }

                let receivedData  = this.toHexString(data.buffer)
                this.receivedData = receivedData
                return receivedData
            }
        }
    }
</script>

<style lang="scss" scoped>
    .characteristic-detail-container {
        padding: 1rem;
        display: flex;
        flex-direction: column;

        .service-container {
            margin-top: 8px;
            border-radius: 8px;
            padding: 4px;
            background-color: antiquewhite;
            border: 1px gray solid;

            .name-container {
                .subtitle {
                    font-size: 12px;
                }

                .service-name {
                    font: 14px bold;
                    font-weight: bolder;
                    word-wrap: break-word;
                }
            }
        }

    }

    .service-title {
        font: 16px bold;
        font-weight: bolder;
        border-bottom: 0.5px gray;
    }

    .properties-button {
        background-color: antiquewhite;
        border-radius: 8px;
        padding: 2px 12px;
        margin-left: 8px;

    }

    .write-dialog {
        width: 80%;
    }
</style>